import React from "react";
import { useOnlineStatus, useQueueCount } from "@/lib/useOnlineStatus";
import { WifiOff, CloudUpload, AlertTriangle } from "lucide-react";
import { drainQueue } from "@/lib/offline";
import { toast } from "sonner";

export function OfflineStatusBanner() {
  const online = useOnlineStatus();
  const { pending, failed } = useQueueCount();

  if (online && pending === 0 && failed === 0) return null;

  return (
    <div className="flex items-center justify-between gap-2 px-4 py-2 border-b border-zinc-300 text-xs font-mono" data-testid="offline-banner"
      style={{ background: !online ? "#FEF3C7" : failed > 0 ? "#FEE2E2" : "#DBEAFE" }}>
      {!online && (
        <div className="flex items-center gap-2 text-amber-900">
          <WifiOff className="w-3.5 h-3.5" />
          <span className="uppercase tracking-wider">Offline mode — changes will sync when you reconnect.</span>
        </div>
      )}
      {online && pending > 0 && (
        <div className="flex items-center gap-2 text-blue-900">
          <CloudUpload className="w-3.5 h-3.5 animate-pulse" />
          <span className="uppercase tracking-wider">Syncing {pending} pending operation{pending === 1 ? "" : "s"}…</span>
        </div>
      )}
      {failed > 0 && (
        <div className="flex items-center gap-2 text-rose-900">
          <AlertTriangle className="w-3.5 h-3.5" />
          <span className="uppercase tracking-wider">{failed} operation{failed === 1 ? "" : "s"} need attention</span>
        </div>
      )}
      <div className="flex items-center gap-2">
        <a href="/sync" className="uppercase tracking-wider px-2 py-1 border border-current hover:bg-white" data-testid="offline-banner-view-link">View queue</a>
        {online && (pending > 0 || failed > 0) && (
          <button
            data-testid="offline-banner-sync-now"
            onClick={async () => {
              const res = await drainQueue();
              if (res.skipped) toast.message("Sync skipped");
              else if (res.failed > 0 || res.succeeded > 0) toast.success(`Synced ${res.succeeded}, ${res.failed} retried later`);
            }}
            className="uppercase tracking-wider px-2 py-1 border border-current hover:bg-white"
          >
            Sync now
          </button>
        )}
      </div>
    </div>
  );
}
